import { useMutation } from '@apollo/client';
import { ACCOUNT_GET_BUYER_APPLICATIONS } from '@application/api';
import { graphql } from '@gql/gql';
import type {
  MtApplicationsBuyerOpenApplicationMutation,
  MtApplicationsBuyerOpenApplicationMutationVariables,
} from '@gql/graphql';
import { useCallback } from 'react';

export const MT_APPLICATIONS_BUYER_OPEN_APPLICATION = graphql(`
  mutation MtApplicationsBuyerOpenApplication($applicationId: Int!) {
    openApplication(applicationId: $applicationId)
  }
`);

export const useOpenApplication = () => {
  const [open] = useMutation<
    MtApplicationsBuyerOpenApplicationMutation,
    MtApplicationsBuyerOpenApplicationMutationVariables
  >(MT_APPLICATIONS_BUYER_OPEN_APPLICATION, {
    awaitRefetchQueries: true,
    refetchQueries: [ACCOUNT_GET_BUYER_APPLICATIONS],
  });

  const openApplication = useCallback(
    async (applicationId: number) => {
      await open({
        variables: { applicationId },
      });
    },
    [open],
  );

  return {
    openApplication,
  };
};
